import React from 'react';
import styled, { css } from 'styled-components';
import { getAnvspecForKode, getAnvgenForKode } from '../../Map/util/koder';
import { neutral } from '../../../style/colors';

const Anvendelse = (props: IAnvendelsePropTypes) => {
  const { kode, color, bgColor, bygomfang, omfangBgColor } = props;
  const {
    bygpct = undefined, // bebyggelsesprocent
    m3_m2h = undefined, // etagemeter
    m3_m2 = undefined, // rumfang
    maxbhjd = undefined, // byggehøjde
    maxetage = undefined, // antal etager
  } = bygomfang || {};

  const omfangSpan = () => {
    // <sup style={{ fontSize: 10 }}>3</sup>
    const byggeprocent = bygpct ? `Max ${bygpct}%` : null;
    const etagemeter = m3_m2h
      ? bygpct
        ? `, Max ${m3_m2h}m/etg`
        : `Max ${m3_m2h}m/etg`
      : null;
    const rumfang = m3_m2 ? (
      bygpct || m3_m2h ? (
        <span>
          , Max {m3_m2}m<sup style={{ fontSize: 10 }}>3</sup>/m
          <sup style={{ fontSize: 10 }}>2</sup>
        </span>
      ) : (
          <span>
            Max {m3_m2}m<sup style={{ fontSize: 10 }}>3</sup>/m
          <sup style={{ fontSize: 10 }}>2</sup>
          </span>
        )
    ) : null;

    return (
      <span>
        {byggeprocent}
        {etagemeter}
        {rumfang}
      </span>
    );
  };
  const Omfanget =
    bygpct !== undefined || m3_m2h !== undefined || m3_m2 !== undefined ? (
      <Omfang omfangBgColor={omfangBgColor}>
        <span style={{ fontWeight: 400 }}>Omfang:</span> {omfangSpan()}
      </Omfang>
    ) : null;
  const Hojde =
    maxetage !== undefined || maxbhjd !== undefined ? (
      <Omfang omfangBgColor={omfangBgColor}>
        <span style={{ fontWeight: 400 }}>Højde:</span>{' '}
        <span>
          {maxbhjd !== undefined ? `Max ${maxbhjd}m` : null}
          {maxetage !== undefined && maxbhjd !== undefined ? `, ` : null}
          {maxetage !== undefined ? `Max ${maxetage} etg` : null}
        </span>
      </Omfang>
    ) : null;
  const anvendelse = getAnvgenForKode(kode)
    ? getAnvgenForKode(kode)
    : getAnvspecForKode(kode);
  return anvendelse ? (
    <Wrapper>
      <AnvendelseWrapper color={color} bgColor={bgColor}>
        {anvendelse.tekst}
      </AnvendelseWrapper>
      {Omfanget}
      {Hojde}
    </Wrapper>
  ) : (
      <Wrapper>
        <AnvendelseWrapper>Ukendt</AnvendelseWrapper>
      </Wrapper>
    );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const AnvendelseWrapper = styled.div`
  background-color: #ffffff;
  margin: 5px 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  ${props =>
    props.color &&
    css`
      color: ${props.color}};
    `}
  ${props =>
    props.bgColor &&
    css`
      background-color: ${props.bgColor}};
    `}
`;

const Omfang = styled.div`
  background-color: ${neutral[100]};
  ${props =>
    props.omfangBgColor &&
    css`
      background-color: ${props.omfangBgColor}};
    `}
  font-size: 13px;
  font-weight: 600;
  padding: 0 5px;
  height: 30px;
  line-height: 30px;
  margin: 5px 10px 10px 30px;
  position: relative;
  &::before {
    position: absolute;
    left: -10px;
    top: -11px;
    content: '';
    display: block;
    border-left: 2px solid ${neutral[200]};
    height: 30px;
    border-bottom: 2px solid ${neutral[200]};
    width: 10px;
  }
  &::after {
    position: absolute;
    left: -10px;
    bottom: -7px;
    content: '';
    display: block;
    border-left: 2px solid ${neutral[200]};
    height: 100%;
  }
  &:last-child {
    &:after {
      display: none;
    }
  }
`;
interface IAnvendelsePropTypes {
  kode: number;
  bygomfang?: any;
  color?: string;
  bgColor?: string;
  omfangBgColor?: string;
}

export default Anvendelse;
